import React, { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

const Confetti = ({ show, originX, originY, type = 'confetti' }) => {
  const confettiRef = useRef(null); // This ref is not strictly needed for this implementation but kept for consistency

  useEffect(() => {
    // Check if confetti should be shown and if it hasn't been shown in this session yet
    // sessionStorage stores values as strings, so compare with 'true' or null/undefined
    if (show && sessionStorage.getItem('confettiShown') !== 'true') {
      const myCanvas = document.createElement('canvas');
      myCanvas.style.position = 'fixed';
      myCanvas.style.top = '0';
      myCanvas.style.left = '0';
      myCanvas.style.width = '100%';
      myCanvas.style.height = '100%';
      myCanvas.style.pointerEvents = 'none'; // Allows clicks to pass through
      myCanvas.style.zIndex = '9999'; // Ensure it's on top
      document.body.appendChild(myCanvas);

      const myConfetti = confetti.create(myCanvas, { resize: true, useWorker: true });

      // Trigger the confetti
      myConfetti({
        particleCount: 100,
        spread: 70,
        origin: { x: originX, y: originY },
        colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a']
      });

      // Set a flag in session storage so it doesn't show again in this session
      sessionStorage.setItem('confettiShown', 'true');

      // Clean up the canvas after a short delay
      const timeout = setTimeout(() => {
        if (myCanvas.parentNode) {
          myCanvas.remove();
        }
      }, 3000); // Remove canvas after 3 seconds

      // Cleanup function for useEffect
      return () => {
        clearTimeout(timeout);
        if (myCanvas.parentNode) {
          myCanvas.remove();
        }
      };
    }
  }, [show, originX, originY, type]); // Dependencies for useEffect

  return null; // This component doesn't render any visible DOM elements itself
};

export default Confetti;